export default "__VITE_ASSET__DWJRpcvD__"